import encodeFormData from '../../utilities/js/encodeFormData/encodeFormData.js';

let service;

class Product {
  constructor() {
    this.urls = window.__globalConfig.apiUrls.product;
  }

  getProductEditData(type, productData) {
    if (type === 'cart') {
      return this.getCartEditData(productData);
    }
  }

  getCartEditData(productData) {
    return fetch(
        `${this.urls.cartEdit}?${encodeFormData(productData)}`,
        {credentials: 'include'}
    )
        .then(response => {
          return response.json();
        });
  }

  postNewProductData(url, productData) {
    return fetch(url, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: encodeFormData(productData)
    })
        .then(response => {
          if (response.redirected) {
            location.href = response.url;
          }
          if (response.status === 200) {
            return response.json();
          }
        });
  }
}

function product() {
  if (service) {
    return service;
  } else {
    service = new Product();
    return service;
  }
}

export default product;
